import cx from 'classnames';

export type SimpleModalContentWidth = 320 | 400 | 'auto';

const MODAL_WIDTH_CLASSES: Record<SimpleModalContentWidth, string> = {
  320: 'tw-w-320',
  400: 'tw-w-[400px]',
  auto: '',
};

export interface SimpleModalContentProps {
  /**
   * An emblem above the title.
   *
   * For a modal whose consequence the copy alone understates — a confirm that
   * can stop a running routine reads as ordinary until something says
   * otherwise, and by then the operator has already pressed it.
   */
  icon?: React.ReactNode;
  title?: React.ReactNode;
  children?: React.ReactNode;
  buttons?: React.ReactNode;
  width?: SimpleModalContentWidth;
  centerContent?: boolean;
}

export function SimpleModalContent({
  icon,
  title,
  children,
  buttons,
  width = 320,
  centerContent = true,
}: SimpleModalContentProps) {
  return (
    <div className={cx('tw-py-16', 'tw-flex', 'tw-flex-col', 'tw-text-15')}>
      {icon && (
        <div
          aria-hidden
          className="tw-mb-8 tw-flex tw-justify-center tw-items-center"
        >
          {icon}
        </div>
      )}
      {title && (
        <header
          className={cx(
            'tw-text-17',
            'tw-font-medium',
            'tw-text-ellipsis',
            'tw-text-center',
            'tw-mb-2',
            'tw-mx-auto',
            'tw-px-16',
            MODAL_WIDTH_CLASSES[width],
          )}
        >
          {title}
        </header>
      )}
      <div
        className={cx(
          'tw-flex tw-flex-col tw-mx-auto tw-px-16',
          MODAL_WIDTH_CLASSES[width],
          centerContent && 'tw-text-center',
        )}
      >
        {children}
      </div>
      {buttons && (
        <div
          className={cx(
            'tw-grid',
            'tw-grid-flow-col',
            'tw-auto-cols-fr',
            'tw-gap-12',
            'tw-mt-20',
            'tw-px-16',
            /* avoid squeezing buttons horizontally */
            'tw-min-w-max',
          )}
        >
          {buttons}
        </div>
      )}
    </div>
  );
}
